import styled from '@emotion/styled';

const DropdownWrapper = styled.span({
  display: 'inline-block',
  width: '3.6rem',
});

export default DropdownWrapper;
